module.exports = __webpack_public_path__ + "static/media/photo_036.166d6181.JPG";